import { render, staticRenderFns } from "./ReviewerTipsModal.vue?vue&type=template&id=0063b963&"
import script from "./ReviewerTipsModal.vue?vue&type=script&lang=js&"
export * from "./ReviewerTipsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports